module.exports = __webpack_public_path__ + "static/GT-Super-Display-Light-Italic-7fa58a7e132baa9bad12290df02dbe4c.woff";